import { useState, useRef, useEffect } from "react"
import "./index.css"

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000"
const HISTORY_STORAGE_KEY = "lore_history"
const MAX_HISTORY_ITEMS = 20

const SUGGESTIONS = [
  "Why was the mobile app deprioritized?",
  "Who decided to rebuild the payment module?",
  "What did the team discuss about the Q2 deadline?",
  "What's the status of the authentication ticket?",
  "Who last worked on the onboarding flow?",
]

const SendIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"></line>
    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
  </svg>
)

const SyncIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10"></polyline>
    <polyline points="1 20 1 14 7 14"></polyline>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
  </svg>
)

const SlackIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z"/>
  </svg>
)

const JiraIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.571 11.513H0a5.218 5.218 0 0 0 5.232 5.215h2.13v2.057A5.215 5.215 0 0 0 12.575 24V12.518a1.005 1.005 0 0 0-1.004-1.005zm5.723-5.756H5.757a5.215 5.215 0 0 0 5.214 5.214h2.129v2.058a5.218 5.218 0 0 0 5.215 5.214V6.762a1.005 1.005 0 0 0-1.021-1.005zM23.017 0H11.459a5.215 5.215 0 0 0 5.214 5.215h2.129v2.057A5.215 5.215 0 0 0 24.02 12.49V1.005A1.005 1.005 0 0 0 23.017 0z"/>
  </svg>
)

const SpinnerIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ animation: "spin 1s linear infinite" }}>
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
)

function SourceBadge({ source }) {
  const isSlack = source === "slack"
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      fontSize: 10,
      fontWeight: 500,
      padding: "2px 7px",
      borderRadius: 4,
      background: isSlack ? "rgba(74,21,75,0.4)" : "rgba(0,82,204,0.25)",
      color: isSlack ? "#c084fc" : "#60a5fa",
      border: `1px solid ${isSlack ? "rgba(192,132,252,0.2)" : "rgba(96,165,250,0.2)"}`,
      letterSpacing: "0.03em",
      textTransform: "uppercase"
    }}>
      {isSlack ? <SlackIcon /> : <JiraIcon />}
      {source}
    </span>
  )
}

function HistoryItem({ item, onClick }) {
  return (
    <button
      onClick={() => onClick(item.question)}
      style={{
        display: "block",
        width: "100%",
        textAlign: "left",
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: "8px 12px",
        borderRadius: 6,
        color: "#888",
        fontSize: 13,
        transition: "all 0.15s",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
      onMouseEnter={e => { e.target.style.background = "#1a1a1a"; e.target.style.color = "#ccc" }}
      onMouseLeave={e => { e.target.style.background = "none"; e.target.style.color = "#888" }}
    >
      {item.question}
    </button>
  )
}

function loadHistory() {
  try {
    const raw = localStorage.getItem(HISTORY_STORAGE_KEY)
    if (!raw) return []

    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []

    return parsed
      .filter(item => item && typeof item.question === "string" && typeof item.ts === "number")
      .slice(0, MAX_HISTORY_ITEMS)
  } catch {
    return []
  }
}

export default function App() {
  const [question, setQuestion] = useState("")
  const [answer, setAnswer] = useState(null)
  const [loading, setLoading] = useState(false)
  const [syncing, setSyncing] = useState(false)
  const [syncResult, setSyncResult] = useState(null)
  const [error, setError] = useState(null)
  const [history, setHistory] = useState([])
  const textareaRef = useRef(null)
  const answerRef = useRef(null)

  useEffect(() => {
    setHistory(loadHistory())
  }, [])

  useEffect(() => {
    localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(history.slice(0, MAX_HISTORY_ITEMS)))
  }, [history])

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 200) + "px"
    }
  }, [question])

  useEffect(() => {
    if (answer && answerRef.current) {
      answerRef.current.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }, [answer])

  async function ask(q) {
    const queryText = (q || question).trim()
    if (!queryText || loading) return

    setLoading(true)
    setAnswer(null)
    setError(null)
    setQuestion(queryText)

    try {
      const res = await fetch(`${API_BASE}/query`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question: queryText })
      })
      if (!res.ok) throw new Error(`Server error: ${res.status}`)
      const data = await res.json()
      setAnswer(data.answer)
      setHistory(prev => [{ question: queryText, ts: Date.now() }, ...prev].slice(0, MAX_HISTORY_ITEMS))
    } catch (e) {
      setError(e.message || "Something went wrong.")
    } finally {
      setLoading(false)
    }
  }

  async function syncJira() {
    setSyncing(true)
    setSyncResult(null)
    try {
      const res = await fetch(`${API_BASE}/sync/jira`, { method: "POST" })
      const data = await res.json()
      setSyncResult(`Synced ${data.synced ?? "?"} entries from Jira.`)
    } catch (e) {
      setSyncResult("Jira sync failed - check backend logs.")
    } finally {
      setSyncing(false)
      setTimeout(() => setSyncResult(null), 4000)
    }
  }

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      ask()
    }
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#0a0a0a" }}>
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.4; } }
        .dot-1 { animation: pulse 1.2s ease-in-out infinite; }
        .dot-2 { animation: pulse 1.2s ease-in-out 0.2s infinite; }
        .dot-3 { animation: pulse 1.2s ease-in-out 0.4s infinite; }
      `}</style>

      <aside style={{
        width: 240,
        borderRight: "1px solid #1c1c1c",
        padding: "24px 0",
        display: "flex",
        flexDirection: "column",
        flexShrink: 0
      }}>
        <div style={{ padding: "0 20px 24px", borderBottom: "1px solid #1c1c1c" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{
              width: 28, height: 28, borderRadius: 8,
              background: "linear-gradient(135deg, #7c3aed, #4f46e5)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, fontWeight: 700, color: "white"
            }}>L</div>
            <span style={{ fontSize: 16, fontWeight: 600, color: "#f0f0f0" }}>Lore</span>
          </div>
          <p style={{ fontSize: 11, color: "#555", marginTop: 6, lineHeight: 1.5 }}>
            Organizational memory
          </p>
        </div>

        <div style={{ padding: "16px 20px", borderBottom: "1px solid #1c1c1c" }}>
          <button
            onClick={syncJira}
            disabled={syncing}
            style={{
              display: "flex", alignItems: "center", gap: 7,
              width: "100%", padding: "8px 12px", borderRadius: 6,
              background: syncing ? "#1a1a1a" : "#141414",
              border: "1px solid #222", cursor: syncing ? "not-allowed" : "pointer",
              color: syncing ? "#555" : "#888", fontSize: 12, fontWeight: 500,
              transition: "all 0.15s"
            }}
            onMouseEnter={e => !syncing && (e.currentTarget.style.borderColor = "#333")}
            onMouseLeave={e => e.currentTarget.style.borderColor = "#222"}
          >
            {syncing
              ? <><SpinnerIcon /> Syncing Jira...</>
              : <><SyncIcon /> Sync Jira</>
            }
          </button>
          {syncResult && (
            <p style={{ fontSize: 11, color: "#6ee7b7", marginTop: 8, lineHeight: 1.4 }}>
              {syncResult}
            </p>
          )}
        </div>

        <div style={{ padding: "16px 0", flex: 1, overflowY: "auto" }}>
          {history.length > 0 && (
            <>
              <p style={{ fontSize: 10, color: "#444", fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", padding: "0 20px", marginBottom: 8 }}>
                Recent
              </p>
              {history.map((item, i) => (
                <HistoryItem key={`${item.ts}-${i}`} item={item} onClick={ask} />
              ))}
            </>
          )}
        </div>

        <div style={{ padding: "16px 20px", borderTop: "1px solid #1c1c1c" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 11, color: "#444" }}>
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#22c55e" }} />
            Backend: {API_BASE.replace("http://", "").replace("https://", "")}
          </div>
        </div>
      </aside>

      <main style={{ flex: 1, display: "flex", flexDirection: "column", maxWidth: 800, margin: "0 auto", padding: "60px 40px 40px", width: "100%" }}>
        <div style={{ marginBottom: 48 }}>
          <h1 style={{ fontSize: 28, fontWeight: 600, color: "#f0f0f0", letterSpacing: "-0.02em" }}>
            Ask Lore
          </h1>
          <p style={{ fontSize: 14, color: "#555", marginTop: 6 }}>
            Query your team's Slack history and Jira activity in plain English.
          </p>
        </div>

        {!answer && !loading && (
          <div style={{ marginBottom: 32, animation: "fadeIn 0.4s ease" }}>
            <p style={{ fontSize: 11, color: "#444", fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 12 }}>
              Try asking
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {SUGGESTIONS.map((s, i) => (
                <button
                  key={i}
                  onClick={() => ask(s)}
                  style={{
                    background: "#111", border: "1px solid #222",
                    color: "#888", fontSize: 12, padding: "7px 14px",
                    borderRadius: 20, cursor: "pointer", transition: "all 0.15s"
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = "#444"; e.currentTarget.style.color = "#ccc" }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = "#222"; e.currentTarget.style.color = "#888" }}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>
        )}

        {loading && (
          <div style={{ padding: "24px 0", display: "flex", alignItems: "center", gap: 8, color: "#555", fontSize: 14 }}>
            <span className="dot-1" style={{ display: "inline-block", width: 6, height: 6, borderRadius: "50%", background: "#7c3aed" }} />
            <span className="dot-2" style={{ display: "inline-block", width: 6, height: 6, borderRadius: "50%", background: "#7c3aed" }} />
            <span className="dot-3" style={{ display: "inline-block", width: 6, height: 6, borderRadius: "50%", background: "#7c3aed" }} />
            <span style={{ marginLeft: 4 }}>Searching memory...</span>
          </div>
        )}

        {error && (
          <div style={{ padding: 16, background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)", borderRadius: 8, color: "#f87171", fontSize: 13, marginBottom: 24 }}>
            {error}
          </div>
        )}

        {answer && (
          <div ref={answerRef} style={{ animation: "fadeIn 0.4s ease", marginBottom: 32 }}>
            <div style={{
              display: "flex", justifyContent: "flex-end", marginBottom: 16
            }}>
              <div style={{
                background: "#1a1a1a", border: "1px solid #222",
                borderRadius: "12px 12px 4px 12px",
                padding: "10px 16px", maxWidth: "80%",
                fontSize: 14, color: "#ccc", lineHeight: 1.6
              }}>
                {question}
              </div>
            </div>

            <div style={{ display: "flex", gap: 12 }}>
              <div style={{
                width: 28, height: 28, borderRadius: 8, flexShrink: 0, marginTop: 2,
                background: "linear-gradient(135deg, #7c3aed, #4f46e5)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 12, fontWeight: 700, color: "white"
              }}>L</div>
              <div style={{
                flex: 1, background: "#111", border: "1px solid #1e1e1e",
                borderRadius: "4px 12px 12px 12px",
                padding: "16px 20px",
                fontSize: 14, color: "#d0d0d0", lineHeight: 1.8,
                whiteSpace: "pre-wrap"
              }}>
                {answer}
              </div>
            </div>
          </div>
        )}

        <div style={{ marginTop: "auto" }}>
          <div style={{
            background: "#111",
            border: "1px solid #222",
            borderRadius: 12,
            padding: "12px 16px",
            display: "flex",
            alignItems: "flex-end",
            gap: 12,
            transition: "border-color 0.15s"
          }}
            onFocus={() => {}}
          >
            <textarea
              ref={textareaRef}
              value={question}
              onChange={e => setQuestion(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Ask anything about your organization..."
              rows={1}
              style={{
                flex: 1, background: "none", border: "none", outline: "none",
                color: "#e0e0e0", fontSize: 14, resize: "none",
                lineHeight: 1.6, fontFamily: "inherit",
                minHeight: 24, maxHeight: 200, overflowY: "auto"
              }}
            />
            <button
              onClick={() => ask()}
              disabled={loading || !question.trim()}
              style={{
                width: 32, height: 32, borderRadius: 8, flexShrink: 0,
                display: "flex", alignItems: "center", justifyContent: "center",
                background: loading || !question.trim() ? "#1a1a1a" : "linear-gradient(135deg, #7c3aed, #4f46e5)",
                border: "none", cursor: loading || !question.trim() ? "not-allowed" : "pointer",
                color: loading || !question.trim() ? "#444" : "white",
                transition: "all 0.15s"
              }}
            >
              {loading ? <SpinnerIcon /> : <SendIcon />}
            </button>
          </div>
          <p style={{ fontSize: 11, color: "#333", marginTop: 8, textAlign: "center" }}>
            Enter to send | Shift+Enter for new line
          </p>
        </div>
      </main>
    </div>
  )
}
